import { render } from "./Root.vue?vue&type=template&id=a9768b0a"
import script from "./Root.vue?vue&type=script&lang=js"
export * from "./Root.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ondaa/workspace/schoolmom_qna_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__